export enum PlanogramProblemType {
  MissingDimensions = 'Missing Dimensions',
  MissingImages = 'Missing Images',
  NoSalesOrVolume = 'No Sales / Volume',
  FlowOrderZero = 'Flow Order = 0'
}